// extracted by mini-css-extract-plugin
export default {"mid-box":"AppVersion_mid-box__MPvZ+","content-box":"AppVersion_content-box__5cQsg","top":"AppVersion_top__Wg3Ym","botm":"AppVersion_botm__QFkFn"};